import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  text: '非常专业的服务，环境优雅，技师手法一流。在这里度过了一个非常放松的下午，强烈推荐！',
  author: 'Mr. Zhang',
  role: 'Business Executive',
  rating: 5
}, {
  text: 'Excellent service and privacy. The therapists are highly skilled and professional. Will definitely come back again.',
  author: 'James L.',
  role: 'Regular Client',
  rating: 5
}, {
  text: '体验非常棒，从预约到服务都很顺畅。伴游服务非常贴心，让我的商务行程不再枯燥。',
  author: '王先生',
  role: 'Entrepreneur',
  rating: 5
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-[#faf7f2] relative" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-172">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-173">
              客户评价
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium" data-id="element-174">
              Client Testimonials
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-175">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 relative" data-id="element-176">
              <Quote className="absolute top-6 right-6 text-[#c9a96e]/20" size={48} data-id="element-177" />

              <div className="flex mb-4" data-id="element-178">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={16} className="text-[#c9a96e]" fill="currentColor" data-id="element-179" />)}
              </div>

              <p className="text-gray-600 italic mb-6 leading-relaxed min-h-[80px]" data-id="element-180">
                "{review.text}"
              </p>

              <div className="flex items-center" data-id="element-181">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-serif font-bold" data-id="element-182">
                  {review.author.charAt(0)}
                </div>
                <div className="ml-3" data-id="element-183">
                  <p className="text-sm font-bold text-[#1a1a2e]" data-id="element-184">
                    {review.author}
                  </p>
                  <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-185">
                    {review.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}